export const GET_LINKED_DMS = 'GET_LINKED_DMS';
export const GET_SESSION_VALIDITY = 'GET_SESSION_VALIDITY';
export const RESET_SESSION_VALIDITY = "RESET_SESSION_VALIDITY";